/** @jsxImportSource @emotion/react */
import { footerStyle, footerContentStyle } from "./styles";

export default function Footer() {
    return (
        <footer css={footerContentStyle}>
            <p css={footerStyle}>Brussels</p>
        </footer>
    )
}